// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".xxqVuVFUpVO__WcbadRy{width:100%;margin:0}.xxqVuVFUpVO__WcbadRy>div{width:100%}.xxqVuVFUpVO__WcbadRy select{width:100%}", "",{"version":3,"sources":["webpack://./src/applab/screen-selector.module.scss"],"names":[],"mappings":"AAEA,sBACE,UAAA,CACA,QAAA,CAEA,0BACE,UAAA,CAGF,6BACE,UAAA","sourcesContent":["@use \"color.scss\";\n\n.dropdown {\n  width: 100%;\n  margin: 0;\n\n  > div {\n    width: 100%;\n  }\n\n  select {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdown": "xxqVuVFUpVO__WcbadRy"
};
export default ___CSS_LOADER_EXPORT___;
